<div class="image-info" *ngIf="image?.physicalAddress || image?.lastUpdateTime">
  <div class="info-row" *ngIf="image?.physicalAddress">
    <span class="label">{{ 'COMMON.ADDRESS' | translate }}:</span>
    <span class="value">{{ image?.physicalAddress }}</span>
  </div>
  <div class="info-row" *ngIf="image?.latitude && image?.longitude">
    <span class="label">{{ 'COMMON.GEOLOCATION' | translate }}:</span>
    <span class="value">{{ image?.latitude }} {{ image?.longitude }}</span>
    <div class="map-icon" (click)="mapClicked.emit()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" data-bs-toggle="modal"
        data-bs-target="#showImageMap">
        <path
          d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
          fill="#026962" />
      </svg>
    </div>
  </div>
  <div class="info-row" *ngIf="image?.lastUpdateTime">
    <span class="label">{{ 'COMMON.DATE_AND_TIME' | translate }}:</span>
    <span class="value">{{ image?.lastUpdateTime | date: 'dd/MM/yyyy hh:mm a' }}</span>
  </div>
</div>
